import { toZonedTime as fnsToZonedTime } from 'date-fns-tz';

import { resolveTimeZone } from './timezone';

type ToZonedDateOptions = {
  date?: Date | string | number;
  timeZone?: string;
};

/**
 * Converts a date to a store's timezone. Both options fall back independently,
 * so you can pass only a timezone: `toZonedDate({ timeZone })`.
 */
export function toZonedDate({
  date = new Date(),
  timeZone = resolveTimeZone(),
}: ToZonedDateOptions = {}): Date {
  try {
    const sourceDate = date ? new Date(date) : new Date();
    return fnsToZonedTime(sourceDate, timeZone);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error converting date to zoned time:', error);
    return new Date(date);
  }
}
